import { render, staticRenderFns } from "./EarningTaskComponent.vue?vue&type=template&id=a65bfd60"
import script from "./EarningTaskComponent.vue?vue&type=script&lang=js"
export * from "./EarningTaskComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports